import { render, staticRenderFns } from "./PageContainer.vue?vue&type=template&id=2b9af2d2"
import script from "./PageContainer.vue?vue&type=script&lang=js"
export * from "./PageContainer.vue?vue&type=script&lang=js"
import style0 from "./PageContainer.vue?vue&type=style&index=0&id=2b9af2d2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports